import { useTimeRangeSelection } from 'hooks/useTimeRangeSelection';
import {
  DateRangeFilter,
  RangePickerQueryParamKeys,
} from '@cast/shared-date-ui';

export const NODE_STORAGE_QUERY_PARAM_KEYS: RangePickerQueryParamKeys = {
  fromDate: 'node_storage_from',
  toDate: 'node_storage_to',
  dateRangePreset: 'node_storage_date_preset',
  timeZone: 'node_storage_timezone',
};

const DEFAULT_NODE_STORAGE_PRESET = DateRangeFilter.Last7Days;

export const NODE_STORAGE_FILTER_PRESETS = [
  DateRangeFilter.Last15Mins,
  DateRangeFilter.Last30Mins,
  DateRangeFilter.LastHour,
  DateRangeFilter.Last6Hours,
  DateRangeFilter.Today,
  DEFAULT_NODE_STORAGE_PRESET,
  DateRangeFilter.Last2Weeks,
  DateRangeFilter.Last30Days,
  DateRangeFilter.PreviousWeek,
];

export const useNodeStorageTimeRangeSelection = () => {
  return useTimeRangeSelection({
    queryParamKeys: NODE_STORAGE_QUERY_PARAM_KEYS,
    initialState: {
      preset: DEFAULT_NODE_STORAGE_PRESET,
    },
    constraints: {
      maxNumberOfDays: 29,
    },
    allowTimeInput: true,
  });
};
